module.exports = __webpack_public_path__ + "img/logo.e778675d.png";